/* ------------------------- External Dependencies -------------------------- */
import React from 'react'
import styled from 'styled-components'
/* ------------------------- Internal Dependencies -------------------------- */
import assets from 'assets'
import { Flex, Box } from 'particles'
import { BackgroundImage, Button, Container, Image, Heading, Link, Paragraph, Section } from 'atomic'
import { ButtonLink } from 'fusion'
/* --------------------------- Styled Components ---------------------------- */
/* ------------------------- Component Properties --------------------------- */
/* ------------------------------- Component -------------------------------- */
export default props => (
<Section {...props}>
  <Box bg={['white']} py={[20,40]} >
    <Container textAlign={['center']} w={[1,1, 720]} >
      <Heading f={[5,6]} level={[3]} color={['blueLight']} fontWeight={[700]} >Join The Community</Heading>
      <Paragraph f={[]}>Want to get involved?</Paragraph>
      <Paragraph f={[]}>https://github.com/KamesCG/nighthowl</Paragraph>
    </Container>
   </Box>
</Section>
)


// WEBPACK FOOTER //
// ./src/interface/workshop/sections/FooterContext/index.js